var _circle, _path, _circle2, _circle3, _path2, _path3, _path4, _path5, _path6, _path7, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReactionYay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.2321,
    cy: 23.2321,
    r: 22.2321,
    fill: "#F85A17",
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.5379 22.1059C35.5379 29.1666 29.8141 34.8904 22.7533 34.8904C15.6926 34.8904 9.96875 29.1666 9.96875 22.1059C9.96875 15.0451 15.6926 9.32129 22.7533 9.32129C29.8141 9.32129 35.5379 15.0451 35.5379 22.1059Z",
    fill: "#FBF2C3"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.4478,
    cy: 21.7701,
    r: 3.66071,
    fill: "url(#paint0_radial_392_16953)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.4478,
    cy: 21.7701,
    r: 3.66071,
    fill: "url(#paint1_radial_392_16953)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9464 18.8424C34.9464 20.8641 33.3075 22.5031 31.2857 22.5031C29.264 22.5031 27.625 20.8641 27.625 18.8424C27.625 16.8206 29.264 15.1816 31.2857 15.1816C33.3075 15.1816 34.9464 16.8206 34.9464 18.8424Z",
    fill: "url(#paint2_radial_392_16953)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9464 18.8424C34.9464 20.8641 33.3075 22.5031 31.2857 22.5031C29.264 22.5031 27.625 20.8641 27.625 18.8424C27.625 16.8206 29.264 15.1816 31.2857 15.1816C33.3075 15.1816 34.9464 16.8206 34.9464 18.8424Z",
    fill: "url(#paint3_radial_392_16953)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1562 18.26C18.9705 17.5668 18.2579 17.1554 17.5647 17.3411C16.8714 17.5269 16.46 18.2395 16.6458 18.9327L16.1383 19.0687C15.8774 18.0952 16.4551 17.0945 17.4287 16.8337C18.4022 16.5728 19.4029 17.1505 19.6637 18.1241L19.1562 18.26Z",
    fill: "#262626"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.2875 16.7784C27.1506 16.0738 26.4685 15.6137 25.7639 15.7507C25.0594 15.8876 24.5993 16.5698 24.7363 17.2743L24.2205 17.3745C24.0282 16.3852 24.6743 15.4272 25.6637 15.2349C26.653 15.0426 27.611 15.6887 27.8033 16.6781L27.2875 16.7784Z",
    fill: "#262626"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1643 23.8184C19.6018 23.9064 21.5381 23.7328 23.628 23.2703C25.718 22.8078 27.5467 22.1483 28.8129 21.462C29.4477 21.118 29.9274 20.7745 30.2287 20.456C30.5376 20.1296 30.6124 19.8819 30.5744 19.7101L31.0874 19.5966C31.1829 20.0282 30.9579 20.4498 30.6103 20.8172C30.2552 21.1924 29.7218 21.567 29.0633 21.9239C27.7431 22.6395 25.8653 23.3133 23.7416 23.7833C21.6178 24.2532 19.631 24.4346 18.1322 24.3428C17.3846 24.297 16.7429 24.1824 16.2626 23.992C15.7925 23.8056 15.4107 23.5183 15.3152 23.0867L15.8282 22.9732C15.8662 23.145 16.0385 23.338 16.4563 23.5036C16.8638 23.6652 17.4437 23.7742 18.1643 23.8184Z",
    fill: "#262626"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1643 23.8184C19.6018 23.9064 21.5381 23.7328 23.628 23.2703C25.718 22.8078 27.5467 22.1483 28.8129 21.462C29.4477 21.118 29.9274 20.7745 30.2287 20.456C30.5376 20.1296 30.6124 19.8819 30.5744 19.7101L31.0874 19.5966C31.1829 20.0282 30.9579 20.4498 30.6103 20.8172C30.2552 21.1924 29.7218 21.567 29.0633 21.9239C27.7431 22.6395 25.8653 23.3133 23.7416 23.7833C21.6178 24.2532 19.631 24.4346 18.1322 24.3428C17.3846 24.297 16.7429 24.1824 16.2626 23.992C15.7925 23.8056 15.4107 23.5183 15.3152 23.0867L15.8282 22.9732C15.8662 23.145 16.0385 23.338 16.4563 23.5036C16.8638 23.6652 17.4437 23.7742 18.1643 23.8184Z",
    fill: "#262626"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_392_16953",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.4478 21.7701) rotate(90) scale(3.66071)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CEECB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBF2C3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_392_16953",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.4478 21.7701) rotate(90) scale(3.66071)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CEECB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBF2C3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_392_16953",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.5536 18.8424) rotate(90) scale(3.66071)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CEECB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBF2C3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_392_16953",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.5536 18.8424) rotate(90) scale(3.66071)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CEECB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBF2C3"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReactionYay);
export default __webpack_public_path__ + "static/media/reaction_yay.8319387c1b5ad391b1b5b090ae3c9048.svg";
export { ForwardRef as ReactComponent };